import React from "react";
import Card from "components/card";
import CardMenu from "components/card/CardMenu";

import {
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";


export default function DataTable({
  title,
  columns,
  data,
  loading,
  onAdd,
  addButtonText = "Add",
}) {
  const [sorting, setSorting] = React.useState([]);

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return (
    <Card extra="w-full p-6">

      {/* Header */}

      <div className="mb-5 flex items-center justify-between">

        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          {title}
        </h4>

        <div className="flex gap-3">

          <CardMenu />

          <button
            onClick={onAdd}
            className="rounded-lg bg-brand-500 px-5 py-2 text-white hover:bg-brand-600"
          >
            + {addButtonText}
          </button>

        </div>

      </div>

      {/* Table */}

      <div className="overflow-x-auto">

        <table className="w-full">

          <thead>

            {table.getHeaderGroups().map((headerGroup) => (

              <tr key={headerGroup.id}>

                {headerGroup.headers.map((header) => (

                  <th
                    key={header.id}
                    onClick={header.column.getToggleSortingHandler()}
                    className="cursor-pointer border-b pb-3 text-left text-xs font-bold uppercase text-gray-500"
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </th>

                ))}

              </tr>

            ))}

          </thead>

          <tbody>

            {loading ? (

              <tr>

                <td
                  colSpan={columns.length}
                  className="py-10 text-center"
                >
                  Loading...
                </td>

              </tr>

            ) : table.getRowModel().rows.length === 0 ? (

              <tr>

                <td
                  colSpan={columns.length}
                  className="py-10 text-center text-gray-500"
                >
                  No Data Found
                </td>

              </tr>

            ) : (

              table.getRowModel().rows.map((row) => (

                <tr
                  key={row.id}
                  className="border-b hover:bg-dark-50"
                >

                  {row.getVisibleCells().map((cell) => (

                    <td
                      key={cell.id}
                      className="py-4"
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>

                  ))}

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

      

    </Card>
  );
}